module.exports = __webpack_public_path__ + "d4ec01c27de76191217446f582aa4086.MP3";